import Vue from 'vue'
import ApiService from '@/common/api.service'

export const state = {
  /*
   * clientSelectionSets is a "grouping" of multiple clients that are
   * selected. For example, one might wish to have a "global" set of
   * selected clients that is persistent across all screens or one
   * might want to create a set of selected clients for a particular
   * individual/group of widgets.
   */
  clientSelectionSets: {}
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @param state Object
   *
   * @return Object
   */
  get (state) {
    return state
  },

  /**
   * Returns the sets of selected clients.
   *
   * @param state Object
   *
   * @return Object
   */
  clientSelectionSets (state) {
    return state.clientSelectionSets
  }
}

export const actions = {
  /**
   * Query/find one or more clients.
   *
   * @param context Object
   * @param params  Array of query key's and values
   *
   * @return Promise
   */
  query (context, params) {
    return ApiService
      .get(`clients`, params)
      .then((response) => {
        return response
      })
  },

  /**
   * Query/find recently access clients for monitored vehicles/units.
   *
   * @param context Object
   * @param params  Array of query key's and values
   *
   * @return Promise
   */
  queryRecentlyMonitored (context, params) {
    return ApiService
      .get(`users/recent/monitoring/clients`, params)
      .then((response) => {
        return response
      })
  }
}

export const mutations = {
  /**
   * Add a map or array of object clients that have been selected within
   * the specified set.
   *
   * @param state    Object
   * @param set      String
   * @param clients Array|Map
   */
  addSelectedClients (state, { set, clients }) {
    if (!state.clientSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.clientSelectionSets, set, {})
    }

    clients.forEach(client => {
      Vue.set(state.clientSelectionSets[set], client.id, client)
    })
  },

  /**
   * Set a single selected client, all other selected clients
   * in the set will be cleared.
   *
   * @param state  Object
   * @param set    String
   * @param client Object
   */
  setSelectedClient (state, { set, client }) {
    Vue.set(state.clientSelectionSets, set, {})
    Vue.set(state.clientSelectionSets[set], client.id, client)
  },

  /**
   * Removes an array of clients from the set's list of selected clients.
   * The array must consist of the id's of the clients that are no
   * longer selected.
   *
   * @param state    Object
   * @param set      String
   * @param clients Array
   */
  removeSelectedClients (state, { set, clients }) {
    if (state.clientSelectionSets.hasOwnProperty(set)) {
      clients.forEach(client => {
        Vue.delete(state.clientSelectionSets[set], client.id)
      })
    }
  },

  /**
   * Clears all selected clients.
   *
   * @param state  Object
   */
  clearAllSelectedClients (state) {
    Vue.set(state, 'clientSelectionSets', {})
  },

  /**
   * Clears all selected clients within a specified set.
   *
   * @param state  Object
   * @param set      String
   */
  clearSelectedClients (state, set) {
    if (state.clientSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.clientSelectionSets, set, {})
    }
  },

  /**
   * Clears all clients.
   *
   * @param state Object
   */
  purge (state) {
    state.clientSelectionSets = {}
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/administration/clients/findClientsWidgetModule.js